(() => {
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.beginners-guide-posts-menu-item, .beginners-guide-block-read a').forEach(item => {
      const sectionId = item.hash.substring(1);
      const section = document.getElementById(sectionId);

      if (!section) {
        return;
      }

      item.addEventListener('click', e => {
        e.preventDefault();

        document.querySelector('content-navigation-bar').scrollToSection(sectionId);
      });
    });
  });
})();

class ContentNavigationBar extends BaseElement
{
  constructor ()
  {
    super();

    this.cssClass = {
      show: 'content-navigation-bar-show'
    };
    this.sections = [];
    this.scrollOffset = 100;
    this.scrollOffsetDesktop = 33;
    this.currentIndex = 0;
    this.currentSection = null;
    this.localChange = false;
  }

  init ()
  {
    this.querySelector('select').addEventListener('input', e => this.scrollToCurrent());
    this.querySelector('select').addEventListener('change', e => this.scrollToCurrent());

    this.querySelector('.content-navigation-bar-prev').addEventListener('click', e => {
      e.preventDefault();

      this.changeToPrev();
    });

    this.querySelector('.content-navigation-bar-next').addEventListener('click', e => {
      e.preventDefault();

      this.changeToNext();
    });

    window.addEventListener('resize', e => {
      this.updateSections();
      this.updateProgress();
    });

    window.addEventListener('scroll', e => {
      this.updateSections();
      this.updateProgress();
    });

    document.body.prepend(this);
    this.classList.add('initialized');
    this.updateSections();
    this.updateProgress();
  }

  updateSections ()
  {
    this.sections = [];

    this.querySelectorAll('select option').forEach(option => {
      const section = document.getElementById(option.value);

      if (section) {
        this.sections.push({
          top: section.offsetTop,
          section: section
        });
      } else {
        option.remove();
      }
    });

    if (this.querySelector('progress-bar-select')) {
      this.querySelector('progress-bar-select').refresh();
    }

    this.sections = this.sections.sort((a, b) => a.top > b.top ? 1 : -1);
  }

  updateProgress ()
  {
    const scroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = (scroll / height) * 100;
    const headerOffset = window.innerWidth <= 767 && document.body.classList.contains('section-header-show')
      ? document.querySelector('header').offsetHeight
      : 0;

    // Show this only on mobile
    if (window.innerWidth > 767) {
      document.body.classList.remove(this.cssClass.show);

      return;
    }

    if (scroll + this.scrollOffset + headerOffset >= this.sections[0].top) {
      const lastSection = this.sections[this.sections.length - 1];
      this.currentSection = null;
      this.currentIndex = 0;

      this.sections.forEach((section, index) => {
        if (scroll + this.scrollOffset + headerOffset >= section.top) {
          this.currentSection = section;
          this.currentIndex = index;
        }
      });

      if (this.currentIndex + 1 === this.sections.length
        && scroll + this.scrollOffset + headerOffset > lastSection.top + lastSection.section.offsetHeight
      ) {
        this.currentSection = null;
      }

      if (this.currentSection) {
        if (this.querySelector('select').value !== this.currentSection.section.id) {
          this.localChange = true;
          this.querySelector('select').value = this.currentSection.section.id;
          this.querySelector('select').dispatchEvent(new Event('change'));
        }

        document.body.classList.add(this.cssClass.show);
      } else {
        document.body.classList.remove(this.cssClass.show);
      }
    } else {
      document.body.classList.remove(this.cssClass.show);
    }

    this.querySelector('.content-navigation-bar-progress-bar').style.width = scrolled + '%';
  }

  scrollToSection (id)
  {
    const section = document.getElementById(id);

    if (!section) {
      return;
    }

    const header = document.querySelector('header');

    if (window.innerWidth <= 767 && this.currentSection
      && this.currentSection.top > section.offsetTop
    ) {
      window.scrollTo(0, section.offsetTop - this.scrollOffset - header.offsetHeight);
    } else {
      if (window.innerWidth > 767) {
        window.scrollTo(0, section.offsetTop - this.scrollOffsetDesktop - header.offsetHeight);

        // Fix weird issue with different offset top
        setTimeout(() => {
          window.scrollTo(0, section.offsetTop - this.scrollOffsetDesktop - header.offsetHeight);
        }, 333);
      } else {
        window.scrollTo(0, section.offsetTop - this.scrollOffset);

        // Fix weird issue with different offset top
        setTimeout(() => {
          window.scrollTo(0, section.offsetTop - this.scrollOffset);
        }, 333);
      }
    }
  }

  scrollToCurrent ()
  {
    if (this.localChange) {
      this.localChange = false;

      return;
    }

    this.scrollToSection(this.querySelector('select').value);
  }

  changeToPrev ()
  {
    if (this.currentIndex > 0) {
      this.querySelector('select').value = this.sections[this.currentIndex - 1].section.id;
      this.querySelector('select').dispatchEvent(new Event('change'));
    }
  }

  changeToNext ()
  {
    if (this.currentIndex < this.sections.length - 1) {
      this.querySelector('select').value = this.sections[this.currentIndex + 1].section.id;
      this.querySelector('select').dispatchEvent(new Event('change'));
    }
  }
}

if (!customElements.get('content-navigation-bar')) {
  customElements.define('content-navigation-bar', ContentNavigationBar);
}

class ContentNavigationGoTop extends BaseElement
{
  init ()
  {
    document.body.prepend(this);

    this.querySelector('a').addEventListener('click', e => {
      e.preventDefault();

      window.scrollTo(0, 0);
    });

    window.addEventListener('scroll', e => {
      this.update();
    });

    this.update();
  }

  update ()
  {
    const scroll = document.body.scrollTop || document.documentElement.scrollTop;

    if (scroll > 0) {
      this.classList.add('show');
    } else {
      this.classList.remove('show');
    }
  }
}

if (!customElements.get('content-navigation-go-top')) {
  customElements.define('content-navigation-go-top', ContentNavigationGoTop);
}